export default "__VITE_ASSET__DkicjLVc__"